export const {
  REACT_APP_API_URL: API_URL,
  REACT_APP_API_URL_LIVE: LIVE_API_URL,
} = process.env;
export const TOKEN = "TOKEN";
export const API = API_URL;
